module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "cart-pay"
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (totalNumber),
      expression: "totalNumber"
    }],
    staticClass: "cart-price"
  }, [_m(0), " ", _h('span', {
    staticClass: "num"
  }, [_s(totalNumber) + "个菜"]), " ", _h('span', {
    staticClass: "price"
  }, ["￥" + _s(totalPrice)]), " ", _m(1)]), " ", _h('transition', {
    attrs: {
      "name": "gotomenu"
    }
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!totalNumber),
      expression: "!totalNumber"
    }],
    staticClass: "goto-menu"
  }, [_h('router-link', {
    attrs: {
      "to": "/"
    }
  }, ["查看菜单"])])])])
}},staticRenderFns: [function (){with(this) {
  return _h('span', {
    staticClass: "desc"
  }, ["总计： "])
}},function (){with(this) {
  return _h('span', {
    staticClass: "pay"
  }, ["确认下单"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-72706537!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartPay.vue
 ** module id = 76
 ** module chunks = 1
 **/